export enum UseOfGoodsGroupType {
  ByRecipes = 1,
  ByStockMovements = 2
}